import { CommonModule } from '@angular/common';
import { Component, effect, Inject, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonToggle } from '@ionic/angular/standalone';

import { ClientUserService, ProUserService, ToastService } from '../../services';
import { GlobalsInterface } from '../../types';

@Component({
    selector: 'lib-notification-settings-form',
    imports: [CommonModule, IonToggle, FormsModule],
    templateUrl: './notification-settings-form.component.html',
    styleUrl: './notification-settings-form.component.css'
})
export class NotificationSettingsFormComponent {
    /* eslint-disable */
    clientUserService = inject(ClientUserService);
    proUserService = inject(ProUserService);
    toastService = inject(ToastService);

    @Input() userType: 'client' | 'guard' | null = null;

    appType: 'client' | 'pro' | null = null;

    throttleShouldWait = false;

    notificationTypes = {
        notify_on_new_jobs: true,
        notify_on_system_updates: true
    };

    constructor(@Inject('globals') globals: GlobalsInterface) {
        this.appType = globals.appType;

        effect(() => {
            const user = this.appType === 'client' ? this.clientUserService.user() : this.proUserService.user();
            this.notificationTypes.notify_on_new_jobs = !!user?.notify_on_new_jobs;
            this.notificationTypes.notify_on_system_updates = !!user?.notify_on_system_updates;
        });
    }

    onToggleChange() {
        // Throttle the toggle change event with a simple setTimeout and flag throttleShouldWait
        // Prevents multiple api calls when the user is toggling quickly
        if (this.throttleShouldWait) return;

        this.throttleShouldWait = true;

        setTimeout(() => {
            this.throttleShouldWait = false;
            this.updateUserNotificationSettings();
        }, 500);
    }

    updateUserNotificationSettings() {
        this.appType === 'client' ? this.updateClientNotificationSettings() : this.updateGuardNotificationSettings();
    }

    updateClientNotificationSettings() {
        //TO DO - allow notification update when client's notification settings are worked on
    }

    updateGuardNotificationSettings() {
        console.log(this.notificationTypes);
        this.proUserService.updateAccount(this.notificationTypes).subscribe({
            next: data => {
                if (data.success) {
                    this.displaySuccessToast();
                    this.proUserService.setUserFieldValues({
                        notify_on_new_jobs: this.notificationTypes.notify_on_new_jobs === true ? 1 : 0,
                        notify_on_system_updates: this.notificationTypes.notify_on_system_updates === true ? 1 : 0
                    });
                } else {
                    this.displayErrorToast();
                }
            },
            error: () => {
                this.displayErrorToast();
            }
        });
    }

    displaySuccessToast() {
        this.toastService.successToast({ message: 'Updated notification preferences', duration: 300 });
    }

    displayErrorToast() {
        this.toastService.errorToast({ message: 'There was an error. Please try again later.', duration: 300 });
    }
}
